import React, { useEffect, useState } from 'react';


const FiltersBar = ({
  filters,
  setFilters,
  onApply,                         // (next) => void
  onExport,                        // () => void
  onRefresh,                       // () => void
}) => {
  
  const handleReset = () => {
    setFilters({ q: '', status: '', from: '', to: '' });
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="form-row align-items-end">
          <div className="form-group col-md-4">
            <label className="small mb-1">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="MSISDN, refs, router, plan, narration…"
              value={filters.q}
              onChange={(e) => setFilters({ ...filters, q: e.target.value })}
            />
          </div>

          <div className="form-group col-md-3">
            <label className="small mb-1">Status</label>
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            >
              <option value="">All</option>
              <option value="1">Pending</option>
              <option value="3">Successful</option>
              <option value="2">Failed</option>
            </select>
          </div>

          <div className="form-group col-md-5">
            <label className="small mb-1">Date Range</label>
            <div className="d-flex">
              <input
                type="date"
                className="form-control mr-2"
                value={filters.from}
                onChange={(e) => setFilters({ ...filters, from: e.target.value })}
              />
              <input
                type="date"
                className="form-control"
                value={filters.to}
                onChange={(e) => setFilters({ ...filters, to: e.target.value })}
              />
            </div>
          </div>

          <div className="form-group col-md-12 mt-2 mb-0 d-flex">
            <button className="btn btn-primary mr-2" onClick={() => onApply?.(filters)}>
              <i className="fas fa-filter mr-1" /> Apply
            </button>
            <button className="btn btn-outline-secondary" onClick={handleReset}>
              Reset
            </button>

            <div className="ml-auto">
              {/* <button className="btn btn-outline-secondary mr-2" onClick={onExport}>
                <i className="fas fa-file-export mr-1" /> Export CSV
              </button> */}
              <button className="btn btn-outline-secondary" onClick={onRefresh}>
                <i className="fas fa-sync mr-1" /> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;
